// import routes
import {EXTERNAL_LINKS} from './routes';
// import image
import logo from "../images/logo_header.png";

export const headerLogo = logo;

export const headerItems = [
  {
    key: "1", 
    value: EXTERNAL_LINKS.IMETALAB_HOME, 
    iconType: "home", // antd icons
    label: "iMetaLab"
  },
  {
    key: "2", 
    value: EXTERNAL_LINKS.IMETALAB_ABOUT, 
    iconType: "mail", // antd icons
    label: "Contact"
  },
  {
    key: "3", 
    value: EXTERNAL_LINKS.IMETALAB_RESOURCE, 
    iconType: "question-circle", // antd icons
    label: "FAQ"
  },
  {
    key: "4", 
    value: EXTERNAL_LINKS.IMETALAB_CONTACT, 
    iconType: "contacts", // antd icons
    label: "Discussion"
  },
  {
    key: "5", 
    value: EXTERNAL_LINKS.IMETALAB_TERMS, 
    iconType: "info-circle", // antd icons
    label: "Terms"
  },
]